import mainbg from '../../../assests/mainbg.jpg'
import darkbg from '../../../assests/darkbg.jpg'
import lightbg from '../../../assests/lightbg.jpg'
import mainbglight from '../../../assests/mainbglight.jpg'


export const darkTheme={
    primaryColor:'#ff72bf',
    mainbg:mainbg,
    darkBg:darkbg,
    toggleBtn:"-2",
    fontColor:'#FFFFFF',
    secColor:'#191b7d',
    bgColor:'#211c1ca6'
}


export const lightTheme={
    primaryColor:'#02c8f5',
    mainbg:mainbglight,
    darkBg:lightbg,
    toggleBtn:"-10",
    fontColor:'rgb(0 0 0)',
    secColor:'#191b7d',
    bgColor:'#e2e0eca8'
}